/**
 * Dependencies
 */
import http from '../../../../services/HttpService'

/**
 * Change the active step
 *
 * @param  {Function} options.commit
 * @param  {String} step
 * @return {Promise}
 */
const changeStep = ({ commit }, step) => commit('CHANGE_STEP', step)

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Upload a P&L or rent roll file
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const uploadFile = ({ state, commit }, form) => {
    commit('SET_LOADING')
    http.post(`servicing/collaterals/${state.context}/uploads/`, form)
        .then(res => {
            commit('SET_DATA_SUCCESS', res.data)
            commit('RESET_LOADING')
        })
        .catch(err => {
            commit('SET_DATA_FAILURE', err.response.data)
            commit('RESET_LOADING')
        })
}

/**
 * Toggle the uploader modal and set the collateral context
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
const toggleModal = ({ commit }, id) => {
    commit('SET_CONTEXT', id)
    commit('TOGGLE_MODAL')
}

/**
 * Toggle the PNL input/output visibility
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const toggleInputBindings = ({ commit }) => commit('TOGGLE_PNL_INPUT')

/**
 * Reset the P&L state objects
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetPnlState = ({ commit }) => commit('RESET_PNL_STATE')

/**
 * Update a P&L category
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const updatePnlCategory = ({ state, commit, dispatch }, payload) => {
    http.patch(`servicing/file_uploads/${state.pnl.meta.pnl_file_id}/`, payload)
        .then(res => {
            commit('SET_DATA_SUCCESS', res.data)
            dispatch('addNotification', {
                title: 'Item Reassigned',
                type: 'success',
                text: 'The line item was successfully recategorized',
                timeout: true
            }, { root: true })
        })
        .catch(e => {
            if (e.response) { commit('SET_DATA_FAILURE', e.response.data) }
            dispatch('addNotification', {
                title: 'Error',
                type: 'error',
                text: 'There was a problem uploading your file.',
                timeout: true
            }, { root: true })
        })
}

/**
 * Download a report
 *
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
const downloadReport = ({ state }, payload) => {
    let id = payload.file_id || state.pnl.meta.pnl_file_id
    return http.post(`servicing/file_uploads/${id}/reports/`, {
        name: payload.name,
        report_type: payload.report_type
    })
}

/**
 * List reports for a given collateral
 *
 * @param  {Object} options.state
 * @return {Void}
 */
const getReports = ({ commit, state }) => {
    http.get(`servicing/collaterals/${state.context}/uploads/`)
        .then(res => commit('SET_REPORTS', res.data))
        .catch(err => console.log(err))
}

const deleteReport = ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
        http.del(`servicing/reports/${payload.id}/`)
            .then(res => {
                dispatch('getReports')
                resolve('Successfully deleted.')
            })
            .catch(err => reject(err))
    })
}

const deleteFile = ({ dispatch }, id) => {
    http.del(`servicing/file_uploads/${id}/`)
        .then(res => dispatch('getReports'))
        .catch(err => console.log(err))
}

export default {
    getReports,
    changeStep,
    resetState,
    uploadFile,
    deleteFile,
    toggleModal,
    deleteReport,
    resetPnlState,
    downloadReport,
    updatePnlCategory,
    toggleInputBindings
}



// WEBPACK FOOTER //
// ./src/state/modules/debt-servicing/uploader/actions.js